import { useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../common/Button'
import Modal from '../../../common/Modal'
import ModalInnerWrapper from '../../../common/ModalInnerWrapper'
import PannelBody from '../../../fragments/PannelBody'
import Backdrop from '../../../common/modal/Backdrop'
import BodySimpleModalV3 from '../../../common/modal/BodySimpleModalV3'
import FormTextareaBox from '../../../common/interactive/FormTextareaBox'
import { hardDeleteCaseDocumentApi } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { caseActions } from '../../../../store/case'

import classes from './DocumentsTabListItem.module.css'

const MIN_REASON_LENGTH = 20

export default function HardDeleteCaseDocument({ document: documentItem }) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [loading, setLoading] = useState(false)
    const [modalOpened, setModalOpened] = useState(false)
    const [reason, setReason] = useState('')
    const [reasonError, setReasonError] = useState('')

    const openModalHandler = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setReason('')
        setReasonError('')
        setModalOpened(true)
    }

    const closeModalHandler = (event) => {
        event?.preventDefault?.()
        event?.stopPropagation?.()
        setModalOpened(false)
        setReason('')
        setReasonError('')
    }

    const hardDeleteHandler = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        const trimmedReason = reason.trim()
        if (trimmedReason.length < MIN_REASON_LENGTH) {
            setReasonError(`Please enter at least ${MIN_REASON_LENGTH} characters.`)
            return
        }

        if (loading) {
            return
        }

        setLoading(true)
        try {
            const result = await hardDeleteCaseDocumentApi(
                userToken,
                activeCase.case.id,
                documentItem.id,
                trimmedReason,
                dispatch
            )

            if (result && result.errorMessage) {
                dispatch(notificationActions.setError(result))
            } else if (result) {
                dispatch(caseActions.replaceWholeItemInDocuments({ payload: result }))
                dispatch(notificationActions.setError({ errorMessage: 'success', type: 'success' }))
                closeModalHandler()
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <BodySimpleModalV3 message="Remove file from Box">
                <Button
                    btnStyle="btn_simple"
                    color="danger"
                    click={openModalHandler}
                    type="button"
                >
                    <i className="ti ti-file-x" />
                    <span className="sr-only">Hard delete document file</span>
                </Button>
            </BodySimpleModalV3>
            {modalOpened && (
                <>
                    {ReactDOM.createPortal(
                        <Backdrop hide={closeModalHandler} />,
                        document.getElementById('backdrop-root')
                    )}
                    {ReactDOM.createPortal(
                        <Modal>
                            <ModalInnerWrapper closeModal={closeModalHandler} modalTitle="Remove file from Box?">
                                <PannelBody>
                                    <form onSubmit={hardDeleteHandler}>
                                        <p className="font-14">
                                            <strong>{documentItem.file_name}</strong> will stay in the deleted list, but the Box file will be permanently removed.
                                        </p>
                                        <p className={`font-14 m-top-12 ${classes.hard_delete_warning}`}>
                                            This document cannot be restored after the file is removed from Box.
                                        </p>
                                        <div className={classes.delete_textarea_spacing}>
                                            <FormTextareaBox
                                                id="hard_delete_case_document_reason"
                                                name="reason"
                                                label="Reason for hard delete"
                                                value={reason}
                                                onChange={(e) => {
                                                    setReason(e.target.value)
                                                    if (reasonError) {
                                                        setReasonError('')
                                                    }
                                                }}
                                                required
                                                helperText={`${reason.trim().length}/${MIN_REASON_LENGTH} characters minimum`}
                                                errorText={reasonError}
                                            />
                                        </div>
                                        <div className={`flex-container-equal m-top-24 ${classes.delete_document_actions}`}>
                                            <Button
                                                btnStyle="btn_danger"
                                                type="submit"
                                                isLoading={loading}
                                                isDisabled={reason.trim().length < MIN_REASON_LENGTH}
                                            >
                                                <i className="ti ti-file-x" /> Yes, remove from Box
                                            </Button>
                                            <Button click={closeModalHandler} type="button">
                                                Cancel
                                            </Button>
                                        </div>
                                    </form>
                                </PannelBody>
                            </ModalInnerWrapper>
                        </Modal>,
                        document.getElementById('overlay-root')
                    )}
                </>
            )}
        </>
    )
}
